import Box from "@mui/material/Box";
import { useRouter } from "next/router";
import type { ReactNode } from "react";
import { LegalAcceptanceBlockingDialog } from "./LegalAcceptanceBlockingDialog";
import { LegalAcceptanceSoftDialog } from "./LegalAcceptanceSoftDialog";
import { useLegalAcceptance } from "./useLegalAcceptance";

type Props = { children: ReactNode };

export function LegalAcceptanceGate({ children }: Props) {
  const router = useRouter();
  const legal = useLegalAcceptance(router.pathname);

  if (legal.exempt) {
    return <>{children}</>;
  }

  return (
    <Box sx={{ position: "relative" }}>
      {children}
      <LegalAcceptanceSoftDialog
        open={legal.mode === "soft"}
        isFirstAcceptancePrompt={legal.isFirstAcceptancePrompt}
        accepting={legal.accepting}
        onAccept={legal.accept}
        onLater={legal.dismissSoft}
      />
      <LegalAcceptanceBlockingDialog
        open={legal.mode === "block"}
        isFirstAcceptancePrompt={legal.isFirstAcceptancePrompt}
        accepting={legal.accepting}
        onAccept={legal.accept}
      />
    </Box>
  );
}
